export default {
    ServerURL:'https://gmsserver.herokuapp.com/',
    Token:'kamjndj&^$2',
    VerifyEmail:'ekmn@#$%08g!~{)',
    SITE_KEY : '6Lc80qggAAAAAAhJ6pydj96aOSb81qfs9T1C3kKH',
    ClientURL:'https://shop.idealtsa.com/'
  };